import { Button } from "@dash/form";
import { useDeviceType } from "@dash/mq";
import { MdOutlineCalendarMonth } from "react-icons/md";
import { useNavigate } from "react-router-dom-v5-compat";
import { getMegaraxPath } from "@megaron/megarax-uri";

type Props = {
  legacyUserId: number;
  className?: string;
};

export const GoToVisitsButton = ({ legacyUserId, className }: Props) => {
  const navigate = useNavigate();

  const { isMobile } = useDeviceType();

  return (
    <Button
      icon={<MdOutlineCalendarMonth />}
      variant="outline"
      size="small"
      onClick={(e) => {
        e.stopPropagation();
        navigate(
          getMegaraxPath.uri("megarax://crm/salesperson-visits/id/{id}/{view}", {
            id: String(legacyUserId),
            view: "week",
          }),
        );
      }}
      className={className}
    >
      {!isMobile && "Wizyty"}
    </Button>
  );
};
